import * as Sentry from '@sentry/browser';
import { sentryBeforeSend } from '@Shared/Helpers/Utilities';

export function initSentry() {
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,

        // Alternatively, use `process.env.npm_package_version` for a dynamic release version
        // if your build tool supports it.
        // release: "my-project-name@2.3.12",
        integrations: [
            // Sentry.browserTracingIntegration(),
            // Sentry.replayIntegration(),
        ],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for tracing.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,

        // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
        tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,

        beforeSend: sentryBeforeSend,
    });

    if (window.sentryUser) {
        Sentry.setUser({
            id: window.sentryUser.id,
            email: window.sentryUser.email,
        });
    }
}
